// Resolve logo URL: full URL used as-is, otherwise path under PUBLIC_URL
function logoUrl(envValue, defaultPath) {
  const base = process.env.PUBLIC_URL || '';
  if (envValue && envValue.trim() !== '') {
    const v = envValue.trim();
    return v.startsWith('http') ? v : `${base}${v.startsWith('/') ? v : `/${v}`}`;
  }
  return `${base}${defaultPath}`;
}

export const Config = {
    APIBaseURL: process.env.REACT_APP_APIBASEURL || process.env.REACT_APP_API_URL || 'http://localhost:8000',
    loginLogo: logoUrl(process.env.REACT_APP_LOGIN_LOGO, '/eucnet_white.png'),
    navbarLogo: logoUrl(process.env.REACT_APP_NAVBAR_LOGO, '/EUCybernet_logo_main_version_transparent_background_rgb.png'),
}

// Static labels (build-time defaults). React components should use useLabels() from LabelsProvider
// for runtime values. These serve as fallback for non-React contexts.
const isCII = (process.env.REACT_APP_PLATFORM_MODE || 'cii') === 'cii';

export const labels = {
    isCII,
    entityName: isCII ? 'OES' : 'Entity',
    entityNameFull: isCII ? 'Operator of Essential Services' : 'Entity',
    entityNamePlural: isCII ? 'OES' : 'Entities',
    entityNamePluralFull: isCII ? 'Operators of Essential Services' : 'Entities',
    platformTitle: process.env.REACT_APP_PLATFORM_TITLE || (isCII ? 'Critical Information Infrastructure' : 'Security Management'),
    platformSubtitle: process.env.REACT_APP_PLATFORM_SUBTITLE || (isCII ? 'Security Management Platform' : 'Risk & Compliance Platform'),
    headerTitle: process.env.REACT_APP_HEADER_TITLE || (isCII ? 'CII Security Management' : 'Security Management'),
    headerSubtitle: process.env.REACT_APP_HEADER_SUBTITLE || (isCII ? 'Critical Infrastructure Protection' : 'Risk & Compliance Platform'),
    brandName: process.env.REACT_APP_BRAND_NAME || 'LAC4',
    showSectorDeps: isCII,
    reportTitle: isCII ? 'CII Assessment Report' : 'Security Assessment Report',
    reportFilenamePrefix: isCII ? 'CII' : 'Security',
}
